import { render, staticRenderFns } from "./click.vue?vue&type=template&id=73d80428&scoped=true&"
import script from "./click.vue?vue&type=script&lang=js&"
export * from "./click.vue?vue&type=script&lang=js&"
import style0 from "./click.vue?vue&type=style&index=0&id=73d80428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d80428",
  null
  
)

export default component.exports